import Styled from 'styled-components';

const NoCommentsStyled = Styled.div`
display:flex;
flex-direction: column;
  & p {
    font-size: 14px;
  }
  & b {
    font-size: 14px;
  }
`;

export default NoCommentsStyled;
export { NoCommentsStyled };
